import type { NumberFormat } from 'libphonenumber-js'
import { format, type ParsedNumber, parseNumber } from 'libphonenumber-js'

function parse(input: string) {
  const parsedNumber = parseNumber(input, {
    extended: true,
  }) as ParsedNumber
  return parsedNumber?.valid ? parsedNumber : undefined
}

export function parsePhoneNumber(phoneNumber?: string) {
  if (phoneNumber) {
    phoneNumber = phoneNumber.trim()
    if (phoneNumber.startsWith('00')) {
      return parse(`+${phoneNumber.substring(2)}`)
    }
    if (phoneNumber.startsWith('+')) {
      return parse(phoneNumber)
    }
  }
}

export function formatPhoneNumber(
  phoneNumber?: string,
  numberFormat?: NumberFormat,
) {
  const parsedPhoneNumber = phoneNumber
    ? parsePhoneNumber(phoneNumber.trim())
    : undefined
  return parsedPhoneNumber
    ? format(parsedPhoneNumber, numberFormat || 'INTERNATIONAL')
    : phoneNumber
}
